import logo from "../logo.png";

/**
 * Shell for the signed-out pages (sign in, sign up, password reset, verify).
 * They previously each rendered their own bare white card on a grey page; this
 * gives them one branded surface so the app looks the same before and after login.
 */
export default function AuthShell({ title, subtitle, children, footer, banner }: any) {
  return (
    <div className="relative min-h-screen min-h-[100dvh] overflow-hidden bg-slate-100 py-10 px-4 sm:px-6">

      <div className="relative mx-auto flex w-full max-w-[460px] flex-col rise">

        <div className="flex flex-col items-center text-center">
          <img src={logo} alt="" className="h-14 w-14 rounded-2xl shadow-md ring-1 ring-slate-200" />
          <h1 className="mt-4 text-2xl font-bold tracking-tight text-slate-900">Remote VPN</h1>
          <div className="mt-1 text-[11px] font-medium uppercase tracking-[0.16em] text-slate-400">
            Version {process.env.REACT_APP_VERSION}
          </div>
        </div>

        {banner}

        <div className="mt-6 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          {title && <div className="text-lg font-bold tracking-tight text-slate-900">{title}</div>}
          {subtitle && <div className="mt-1.5 text-sm leading-relaxed text-slate-500">{subtitle}</div>}
          <div className={title || subtitle ? 'mt-6' : ''}>{children}</div>
        </div>

        {footer && <div className="mt-6 flex flex-col items-center gap-3 text-sm">{footer}</div>}

      </div>
    </div>
  )
}

/** Shared input styling so every auth field matches. */
export const authInput = "block w-full rounded-xl border-0 bg-slate-50 px-3.5 py-2.5 text-slate-900 shadow-sm ring-1 ring-inset ring-slate-200 transition placeholder:text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-emerald-500 disabled:opacity-60";

export const authLabel = "block text-sm font-semibold text-slate-700";

export const authButton = "flex min-h-[44px] w-full flex-row items-center justify-center gap-2 rounded-xl bg-emerald-600 px-3 py-2.5 text-sm font-bold text-white shadow-sm transition-all hover:bg-slate-950 active:scale-[0.99] disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:shadow-none";

export const authLink = "font-bold text-emerald-600 transition hover:text-emerald-700";
